import tween from 'tweeen'
import { sineOut } from 'eases'

function scrollTo(e, id) {
  e && e.preventDefault()
  if (!document.getElementById(id.toLowerCase())) return

  tween(
    window.pageYOffset,
    document.getElementById(id.toLowerCase()).offsetTop,
    (value) => {
      document.scrollingElement.scrollTop = value
    },
    {
      duration: 750,
      easing: sineOut,
      end: () => {
        window.history.pushState('', document.title, window.location.pathname)
      }
    }
  )
}

export default scrollTo
